import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type ChatGroupSolidIconProps = IconProps;

export const ChatGroupSolidIcon = forwardRef<
  SVGSVGElement,
  ChatGroupSolidIconProps
>(function ChatGroupSolidIcon(props: ChatGroupSolidIconProps, ref) {
  return (
    <Icon
      data-testid="ChatGroupSolidIcon"
      aria-label="chat group solid"
      viewBox="0 0 12 12"
      ref={ref}
      {...props}
    >
      <path d="m.113 9.946.321-2.542a4.48 4.48 0 0 1 3.949-6.403A4.469 4.469 0 0 1 7.355 2.04a4.555 4.555 0 0 0-3.454 4.315A4.538 4.538 0 0 0 5.43 9.859a4.473 4.473 0 0 1-3.127-.464l-2.191.551z" />
      <path d="m11.911 9.989-.254-2.011a3.545 3.545 0 0 0-3.125-5.066 3.545 3.545 0 1 0 1.645 6.641l1.733.436z" />
    </Icon>
  );
});
